module.exports = __webpack_public_path__ + "img/undertakingCases15.9588fa37.jpg";